import { createContext, useContext } from "react";

export const NavigationOverlayContext = createContext<{ onNavigate?(): void }>({
  onNavigate: () => {},
});

export const useNavigationOverlayContext = () => {
  return useContext(NavigationOverlayContext);
};
